/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Datatable} from '../../../../components/Datatable/Datatable'
import {Button} from '../../../../components/Button/Button'
import {useNavigate} from 'react-router-dom'
import {GET, PUT, DELETE} from '../../../../services/api'
import {Loading} from '../../../../components/Loading/Loading'
import Swal from 'sweetalert2'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import {i18n} from '../../../../translate/i18n'
//import { ModalDelete } from '../../../../components/Modals/General/ModalDelete/ModalDelete'

type CategoryType = {
  id: number
  parent: string
  code: string
  name: string
  shortname: string
  order: 0
  img: string
  status: true
  subitems: CategoryType[]
}

const Content: FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [categories, setCategories] = useState<any[]>([])
  const [id, setId] = useState<number | null>(null)

  const switchStatus = async (Id: number, status: boolean) => {
    try {
      const switchClassification = await PUT(`/classification/${Id}`, {
        status: !status,
      })
      if (switchClassification.success) {
        const newCategories = categories.map((category) => {
          if (category.id === id) {
            category.status = !status
          }
          init()
          return category
        })
        setCategories(newCategories)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const getCategories = async (search: string = '') => {
    try {
      const res = await GET(`/service-classification`)
      const newCategories = res.data.map((row: CategoryType) => {
        return {
          id: row.id,
          name: `${row.name}`,
          status: row.status,
          code: row.code,
          parent: row.parent,
        }
      })

      setCategories(newCategories)
    } catch (e) {
      console.log(e)
    }
  }

  const deleteCategory = async () => {
    if (!id) {
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('service_category_list.delete.error_title')),
        text: String(i18n.t('service_category_list.delete.error_text')),
      }).then(async () => await getCategories())
    } else {
      try {
        setLoading(true)
        const res = await DELETE(`/service-classification/${id}`)
        if (res.success === true) {
          Swal.fire({
            icon: 'success',
            title: String(i18n.t('service_category_list.delete.success_title')),
            text: String(i18n.t('service_category_list.delete.success_text')),
          }).then(async () => await getCategories())
        } else {
          console.log(res)
          Swal.fire({
            icon: 'error',
            title: String(i18n.t('service_category_list.delete.error_title')),
            text: String(i18n.t('service_category_list.delete.error_text')),
          }).then(async () => await getCategories())
        }
        setLoading(false)
      } catch (e) {
        setLoading(false)
        Swal.fire({
          icon: 'error',
          title: String(i18n.t('service_category_list.delete.error_title')),
          text: e ? String(e) : String(i18n.t('service_category_list.delete.error_text')),
        }).then(async () => await getCategories())
        console.log(e)
      }
    }
  }

  const showDeleteModal = () => {
    Swal.fire({
      title: String(i18n.t('service_category_list.delete.confirm_title')),
      text: String(i18n.t('service_category_list.delete.confirm_text')),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#7e8299',
      cancelButtonText: String(i18n.t('service_category_list.delete.cancel_button')),
      confirmButtonText: String(i18n.t('service_category_list.delete.confirm_button')),
    }).then((result) => {
      if (result.isConfirmed) {
        deleteCategory()
      }
    })
  }

  useEffect(() => {
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const init = async () => {
    setLoading(true)
    await getCategories()
    setLoading(false)
  }

  useEffect(() => {
    if (id) {
      showDeleteModal()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t('service_category_list.page_title')}
                </span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t('service_category_list.page_subtitle')}
                </span>
              </h3>
              <div className='card-toolbar'>
                <Button
                  text={i18n.t('service_category_list.add_button')}
                  color='primary'
                  iconColor='#FFF'
                  icon='fas fa-plus'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate('/hospitality/service-category/create')}
                  btnClass='mb-5 fw-bolder'
                />
              </div>
            </div>
            <div className='card-body'>
              <Datatable
                data={categories}
                headers={[
                  {key: i18n.t('service_category_list.table.name'), value: 'name', type: 'default'},
                  {
                    key: i18n.t('service_category_list.table.status'),
                    value: 'status',
                    type: 'check',
                    action: (item) => switchStatus(item.id, item.status),
                  },
                  {key: i18n.t('service_category_list.table.actions'), value: 'acoes', type: ''},
                ]}
                options={[
                  {
                    icon: 'fas fa-pen',
                    title: i18n.t('service_category_list.actions.edit_category'),
                    action: (item) => {
                      navigate(`/hospitality/service-category/update/${item.id}`)
                    },
                  },
                  {
                    icon: 'fas fa-trash',
                    action: (item) => {
                      setId(item.id)
                    },
                    path: '',
                    title: i18n.t('service_category_list.actions.delete_category'),
                  },
                ]}
                color='primary'
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const Categorias: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {
            title: i18n.t('service_category_list.breadcrumb.categories'),
            path: 'hospitality/service-category',
            isActive: true,
          },
        ]}
      >
        {i18n.t('service_category_list.page_title')}
      </PageTitle>
      <Content />
    </>
  )
}

export {Categorias}
